import React from "react";
import NavbarComponent from "../components/Navbar";

const sectionStyle = {
  minHeight: "100vh",
  background:
    "linear-gradient(180deg, #eef6f9 0%, #dbeaf1 52%, #edf7fb 100%)",
  color: "#0f172a",
};

// system = ระบบที่หน้านี้สังกัด ส่งต่อให้ navbar เลือกชุดเมนูและธีมสี (ค่าเริ่มต้นคือระบบหลัก)
export default function AppShell({ title, description, children, system = "main" }) {
  return (
    <section style={sectionStyle}>
      <NavbarComponent title={title} description={description} system={system} />

      <main
        className="app-shell-main px-2 px-md-3 px-xl-4 pb-3 pb-md-4"
        style={{
          paddingTop: 96,
        }}
      >
        {children}
      </main>

      <style>
        {`
          @media (min-width: 1200px) {
            .app-shell-main {
              /* ความกว้าง sidebar ตั้งโดย Navbar (โหมดปกติ 284px / โหมดย่อ 96px) */
              margin-left: var(--ptn-sidebar-width, 284px);
              padding-top: 81px !important;
              transition: margin-left 260ms cubic-bezier(0.4, 0, 0.2, 1);
            }
          }
        `}
      </style>
    </section>
  );
}
